import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';

export const GRAPHQL_DOCUMENT_USER_PROFILE = gql`
  query currentSession {
    hospitalProfile {
      uid
      firstName
      lastName
      department
      designation
      hospital {
        shortName
      }
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT_USER_PROFILE,
  queryType: 'query',
  baseQueryKey: 'currentSession',
  keepPreviousData: false,
});
